import { cn } from '@april9au/react-common/utils';

/**
 * Shared heading block (eyebrow + title + gold divider + description) used
 * across marketing sections. Not a section on its own — compose it inside
 * page sections that need a consistent header treatment.
 */
export function SectionHeader({
  eyebrow,
  heading,
  description,
  align = 'center',
  className,
}: {
  eyebrow?: string;
  heading: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}) {
  return (
    <div className={cn('section-header', align === 'center' && 'section-header--center', className)}>
      {eyebrow ? <p className="text-eyebrow">{eyebrow}</p> : null}
      <h2 className="text-h2 mt-2">{heading}</h2>
      <span className={cn('divider', align === 'center' && 'divider--center')} />
      {description ? (
        <p className={cn('text-lead max-w-prose', align === 'center' && 'mx-auto')}>{description}</p>
      ) : null}
    </div>
  );
}
